import React, { useState, useEffect } from 'react'
import { message, Spin } from 'antd';
import { Link } from 'react-router-dom';
import DataInputFeild from '../../components/DataInputFeild/DataInputFeild';
import Dropdown from '../../components/Dropdown/Dropdown';
import RadioButton from '../../components/RadioButton/RadioButton';
import TextArea from '../../components/TextArea/TestArea'
import DatePickesr from '../../components/DatePicker/DatePicker'
import FileuploadInput from '../../components/FileuploadInput/FileuploadInput';
import TimePicker from '../../components/TimePicker/TimePicker';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { createSession } from '../../redux/features/sessions/sessionActions'
import { validateForm } from '../../utils/Validation/sessionConstraint';
import LinkInput from '../../components/LinkInput/LinkInput';
import { IoLogoYoutube } from "react-icons/io";
import ToggleBtn from '../../components/ToggleBtn/ToggleBtn';
import NumInput from '../../components/NumInput/NumInput';
import { PrivateAxiosInstance } from '../../services/createAxiosInstance';
import { URLs } from '../../constants/apiEndpoints';
import Table from '../../components/Table/Table';



function AddSession() {
    const [loadingCollection, setLoadingCollection] = useState(false)
    const [isLimitedBtn, setIsLimitedBtn] = useState(false);
    const [isCollectionSection, setIsCollectionSection] = useState(false);
    const [submitCollectionData, setSubmitCollectionData] = useState({
        eventCollectionId: '',
        eventCollectionName: '',
    })
    const [collectionData, setCollectionData] = useState([])

    const [currentPage, setCurrentPage] = useState(1); // Keep track of current page
    const [totalPages, setTotalPages] = useState(1);
    const [selectedCollectionId, setSelectedCollectionId] = useState('');


    const [formData, setFormData] = useState({
        event_name: '',
        description: '',
        presenter: '',
        category: '',
        medium: '',
        date: null,
        startTime: '',
        endTime: '',
        files: null,
        status: '',
        zoomLink: '',
        isLimited: false,
        isCollection: false,
        eventCollectionId: '',
        numOfSeats: 0,
    });
    const [errors, setErrors] = useState({});

    const navigate = useNavigate();
    const dispatch = useDispatch();


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    }


    // Handle status
    const handleStatusChange = (value) => {
        setFormData((prevData) => ({
            ...prevData,
            status: value,
        }));
    };

    //handle dropdown change
    // const handleDropdownChange = (name) => (value) => {
    //     setFormData((prevData) => ({
    //         ...prevData,
    //         [name]: value,
    //     }));

    // };

    const handleDropdownChange = (name) => (value) => {

        if (name === 'collection') {
            setFormData((prevData) => ({
                ...prevData,
                collectionId: value.eventCollectionId,       // Set collectionId
            }));
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };


    //handle date change
    const handleDateChange = (date) => {
        setFormData((prevData) => ({
            ...prevData,
            date,
        }));
    };

    //handle file change
    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData({
            ...formData,
            [name]: files[0], // handling single file upload
        });

    };

    // Handle ToggleBtn change
    const handleToggleChange = (isLimited) => {

        setIsLimitedBtn(isLimited);
        setFormData((prevData) => ({
            ...prevData,
            isLimited,
        }));
    };


    const handleCollectionToggleChange = (newValue) => {
        setIsCollectionSection(newValue);
        setFormData((prevData) => ({
            ...prevData,
            isCollection: newValue,
            eventCollectionId: newValue ? prevData.eventCollectionId : '', // Reset eventCollectionId if isCollection is false
        }));

        if (!newValue) {
            setSelectedCollectionId(''); // Reset the selected collection ID when isCollection is false
        }
    };


    // Handle NumInput change
    const handleNumInputChange = (numOfSeats) => {

        setFormData((prevData) => ({
            ...prevData,
            numOfSeats,
        }));
    };

    const { loading, data } = useSelector((state) => state.session);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const errors = await validateForm(formData); // Validate form data

        // Check if errors exist
        if (errors && Object.keys(errors).length > 0) {
            setErrors(errors);  // Directly set the errors object
            return; // Stop submission if there are errors
        }

        // Create FormData instance to handle both text and file data
        const formDataToSend = new FormData();

        // Loop through formData to append files and non-file fields
        for (const key in formData) {
            if (formData[key] instanceof File) {
                formDataToSend.append(key, formData[key]); // Append file
            } else {
                formDataToSend.append(key, formData[key]); // Append other fields
            }
        }

        try {

            await dispatch(createSession({ formData: formDataToSend })).unwrap();
            message.success('Form submitted successfully!');
            navigate('/admin/session/all')
        } catch (err) {
            console.log('add session err: ', err)
            const errorMessage = err.error || 'Submission failed';
            message.error(errorMessage);
        }
    };



    const handleCollectionChange = (e) => {
        const { name, value } = e.target;
        setSubmitCollectionData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    }


    const createEventCollection = async () => {
        setLoadingCollection(true)
        try {
            const res = await PrivateAxiosInstance.post(URLs.CREATE_EVENT_COLLECTION, submitCollectionData);
            const status = res.status
            if (status === 200) {
                message.success('Event collection created successfully:')
                getCollections()
            }
        } catch (error) {
            const err = error?.response?.data?.error
            if (err) {
                message.error(err)
                console.error('Error creating event collection: ', err)
            } else {
                message.error('Error creating event collection')
                console.error('Error creating event collection: ', error)
            }
        } finally {
            setLoadingCollection(false)
        }
    }


    const getCollections = async (page = 1, limit = 10, search = '', sortBy = 'updatedAt', sortOrder = 'asc') => {
        setLoadingCollection(true);
        try {
            const res = await PrivateAxiosInstance.get(URLs.GET_EVENT_COLLECTIONS, {
                params: { page, limit, search, sortBy, sortOrder },
            });

            const status = res.status;
            if (status === 200) {
                const data = res?.data?.events;
                setCollectionData(data);
                setTotalPages(res?.data?.pages);
            }
        } catch (error) {
            console.error('Error fetching collections:', error?.response?.data?.error);
        } finally {
            setLoadingCollection(false);
        }
    };


    useEffect(() => {
        getCollections(currentPage); // Fetch collections when page changes
    }, [currentPage]);

    // Update the page when user clicks a pagination button
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const categoryOptions = ["Forex", "Trading", "Money Managment", "Risk Managment", "Technical Analysis", " Fundamental Analysis"]
    const languageOptions = ["English", "Sinhala"]



    return (
        <section className={`bg-background-primary-color mt-[20px] mb-[100px] md:mb-[250px] md:mt-[350px] ${isCollectionSection ? 'md:mt-[550px] md:mb-[500px]' : 'md:mt-[150px]'}  `}>

            <Spin spinning={loading} fullscreen />
            <Spin spinning={loadingCollection} fullscreen />


            <div className="flex flex-col items-center justify-center  mx-auto md:h-screen lg:py-0">

                <div className="w-full bg-gray-800 rounded-lg shadow  md:min-w-[800px] lg:min-w-[1000px] md:mt-0 sm:max-w-md xl:p-0 ">

                    <div className="p-6 space-y-4 md:space-y-6 sm:p-8">

                        <h1 className="text-xl font-poppins font-bold leading-tight tracking-tight text-white md:text-2xl ">
                            Create a new session
                        </h1>

                        <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6" >
                            {/* Title */}
                            <DataInputFeild
                                value={formData.event_name}
                                onChange={handleChange}
                                label={"Session Title"}
                                name={"event_name"}
                                type={"text"}
                                required={'required'}
                            />
                            {errors.event_name && <span className="text-red-500 text-xs">{errors.event_name}</span>}
                            {/* hoster */}
                            <DataInputFeild
                                value={formData.presenter}
                                onChange={handleChange}
                                label={"Presenter"}
                                name={"presenter"}
                                type={"text"}
                                required={'required'}
                            />
                            {errors.presenter && <span className="text-red-500 text-xs">{errors.presenter}</span>}

                            <div className="grid md:grid-cols-4  md:gap-6">
                                {/* Error for Date */}
                                <div className="relative z-0 w-full mb-2 group">
                                    {/* Error space */}
                                    {/* date- must be a valid ISO 8601 date string */}
                                    <DatePickesr
                                        value={formData.date}
                                        onChange={handleDateChange}
                                    />
                                    <span className="text-red-500 text-xs h-5 block">
                                        {errors.date || <>&nbsp;</>}
                                    </span>
                                </div>

                                {/* Error for Start Time and End Time */}
                                <div className="relative z-0 w-full mb-2 ml-[-40px] mt-3 sm:mt-0 sm:ml-[-20px] group">
                                    <div className="relative z-0 w-full mb-2 group ml-10">
                                        <label htmlFor="small-input" className="font-poppins block mb-2 text-sm font-medium text-gray-300">
                                            Select start and end time
                                        </label>
                                        <TimePicker
                                            value={[formData.startTime, formData.endTime]}  // Pass startTime and endTime from formData
                                            onChange={([startTime, endTime], [formattedStartTime, formattedEndTime]) => {
                                                setFormData((prevData) => ({
                                                    ...prevData,
                                                    startTime: formattedStartTime,  // Store formatted times
                                                    endTime: formattedEndTime,
                                                }));
                                            }}
                                        />
                                    </div>
                                    {/* Error space for start time */}
                                    <span className="text-red-500 text-xs h-5 block">
                                        {errors.startTime || <>&nbsp;</>}
                                    </span>
                                    {/* Error space for end time */}
                                    <span className="text-red-500 text-xs h-5 block">
                                        {errors.endTime || <>&nbsp;</>}
                                    </span>
                                </div>


                                <div className=" w-full mb-2 mt-4 lg:ml-20 lg:mt-0 group ">
                                    {/* toggle btn */}
                                    <ToggleBtn
                                        value={formData.isLimited}
                                        onChange={handleToggleChange}
                                        title={'Limited Seats'}
                                    />
                                    {/* Error for Status */}
                                    <span className="text-red-500 text-xs h-5 block">
                                        {errors.isLimited || <>&nbsp;</>}
                                    </span>
                                </div>

                                <div className={`w-full mb-2 mt-4 lg:mt-0 group ${isLimitedBtn ? "" : "hidden"}`}>
                                    {/* number input */}
                                    <NumInput
                                        value={formData.numOfSeats}
                                        onChange={handleNumInputChange}
                                        status={isLimitedBtn}
                                    />
                                    {/* Error for Status */}
                                    <span className="text-red-500 text-xs h-5 block">
                                        {errors.numOfSeats || <>&nbsp;</>}
                                    </span>
                                </div>

                            </div>


                            <div className="grid md:grid-cols-3 md:gap-6">


                                <div className=" w-full mb-2 mt-4 lg:mt-0 group ">
                                    {/* Status */}
                                    <RadioButton
                                        value={formData.status}
                                        onChange={handleStatusChange}
                                    />
                                    {/* Error for Status */}
                                    <span className="text-red-500 text-xs h-5 block">
                                        {errors.status || <>&nbsp;</>}
                                    </span>
                                </div>

                                <div className="relative z-0 w-full mb-2 group mt-2 sm:mt-0">
                                    {/* Category */}
                                    <label htmlFor="small-input" className="font-poppins block mb-2 text-sm font-medium text-gray-300">Category</label>
                                    <Dropdown
                                        category={categoryOptions}
                                        value={formData.category}
                                        onChange={handleDropdownChange('category')}
                                        label={"Select a category"}
                                    />
                                    {/* Error for Category */}
                                    <span className="text-red-500 text-xs h-5 block">
                                        {errors.category || <>&nbsp;</>}
                                    </span>
                                </div>

                                <div className="relative z-0 w-full group">
                                    {/* Language */}
                                    <label htmlFor="small-input" className="font-poppins block mb-2 text-sm font-medium text-gray-300">Language</label>
                                    <Dropdown
                                        value={formData.medium}
                                        onChange={handleDropdownChange('medium')}
                                        category={languageOptions}
                                        label={"Select a language"}
                                    />
                                    {/* Error for Language */}
                                    <span className="text-red-500 text-xs h-5 block">
                                        {errors.medium || <>&nbsp;</>}
                                    </span>
                                </div>
                            </div>

                            {/* add to collection */}
                            <div className="grid md:grid-cols-3 md:gap-6 border border-gray-600 rounded-md p-2">


                                <div className="w-full mb-2 mt-4 lg:mt-0 group ">

                                    <ToggleBtn
                                        value={submitCollectionData.isCollection}
                                        onChange={handleCollectionToggleChange}
                                        title={'Add to Collection'}
                                    />
                                    {/* Error for Status */}
                                    <span className="text-red-500 text-xs h-5 block">
                                        {errors.isCollection || <>&nbsp;</>}
                                    </span>
                                </div>

                                <div className={`col-span-2 flex flex-inline mr-3 ${isCollectionSection ? "" : "hidden"}`}>
                                    <DataInputFeild
                                        value={submitCollectionData.eventCollectionName}
                                        onChange={handleCollectionChange}
                                        label={"Collection Title"}
                                        name={"eventCollectionName"}
                                        type={"text"}
                                    />
                                    {errors.eventCollectionName && <span className="text-red-500 text-xs">{errors.eventCollectionName}</span>}

                                    <div className='flex justify-end item-center pl-3 '>
                                        <button
                                            onClick={createEventCollection}
                                            type="button"
                                            className=" font-poppins max-h-[40px] w-[80px] mt-7 text-white bg-gray-500 transition-all duration-300 hover:bg-gray-400 focus:ring-4 focus:outline-none focus:ring-gray-600 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-gray-600">Add
                                        </button>
                                    </div>


                                </div>

                            </div>

                            <div className={` ${isCollectionSection ? "" : "hidden"}`}>
                                {!loadingCollection ? (

                                    <Table
                                        collectionData={collectionData}
                                        currentPage={currentPage}
                                        totalPages={totalPages}
                                        onPageChange={handlePageChange}
                                        selectedCollectionId={selectedCollectionId}
                                        setSelectedCollectionId={(id) => {
                                            setSelectedCollectionId(id);
                                            setFormData((prevData) => ({
                                                ...prevData,
                                                eventCollectionId: id,
                                            }));
                                        }}
                                    />
                                ) : (
                                    <p>Loading...</p>
                                )}
                            </div>

                            {/* Description */}
                            <TextArea
                                value={formData.description}
                                onChange={handleChange}
                                label={"Description"}
                                name={'description'}
                                required={'required'}
                            />
                            {errors.description && <span className="text-red-500 text-xs">{errors.description}</span>}

                            {/* Image uplaod */}
                            <div>
                                <label htmlFor="small-input" className="font-poppins block mb-1 text-sm font-medium text-gray-300">Upload cover image</label>
                                <FileuploadInput
                                    name={'files'}
                                    accept={'image/jpeg,image/png'}
                                    onChange={handleFileChange}
                                />
                            </div>

                            {/* Link uplaod */}

                            <div className="mt-2">
                                <label htmlFor="youtube-link" className="block font-poppins mb-2 text-sm font-medium text-gray-300">
                                    Add Session Link
                                </label>
                                {/* {error && <span className=" font-poppins text-sm text-red-600">{error}</span>} */}

                                <div className="relative mb-5   ">
                                    <div className="absolute inset-y-0 start-0 flex items-center pl-3 pointer-events-none">
                                        <IoLogoYoutube />
                                    </div>
                                    <input
                                        type="text"
                                        name="zoomLink"
                                        value={formData.zoomLink}
                                        onChange={handleChange}
                                        className=' bg-gray-50 border font-poppins border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white '
                                        placeholder="https://zoom.com/example"
                                    />
                                </div>


                            </div>


                            <div className='mb-10 mt-10'></div>

                            {/* Btn */}

                            <div className='flex justify-end '>

                                {/* cancel Btn */}
                                <Link to={'/admin/session/all'}>
                                    <button
                                        type="button"
                                        className="font-poppins w-[100px] mr-3 text-white bg-gray-500 transition-all duration-300 hover:bg-gray-400 focus:ring-4 focus:outline-none focus:ring-gray-600 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-gray-600">Cancel
                                    </button>
                                </Link>
                                <button
                                    type="submit"
                                    className="font-poppins w-[100px]  text-black bg-btn-color transition-all duration-300 hover:bg-btn-hover-color focus:ring-4 focus:outline-none focus:ring-gray-600 font-medium rounded-lg text-sm px-5 py-2.5 text-center ">Submit
                                </button>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default AddSession